/* eslint-disable import/prefer-default-export */

import Vue from 'vue';

let cache = null;
let inProgress = null;

export function getCachedTranslationStatuses() {
  if (cache) {
    return Promise.resolve(cache);
  }

  if (inProgress) {
    return inProgress;
  }

  inProgress = Vue.prototype.$requestHelpers.get('api/admin/getTranslationStatusesLabels')
    .then((response) => {
      cache = response;
      return cache;
    }).finally(() => {
      inProgress = null;
    });

  return inProgress;
}
